import React, { useState } from 'react';
import ResponsabileWorkHours from './ResponsabileWorkHours';
import ResponsabileTimekeeping from './ResponsabileTimekeeping';
import ResponsabileWorkerRequests from './ResponsabileWorkerRequests';
import ResponsabileCantieri from './ResponsabileCantieri';
import './responsabile.css';

const ResponsabileDashboard = () => {
  const [activeTab, setActiveTab] = useState('hours');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'hours':
        return <ResponsabileWorkHours />;
      case 'timekeeping':
        return <ResponsabileTimekeeping />;
      case 'requests':
        return <ResponsabileWorkerRequests />;
      case 'cantieri':
        return <ResponsabileCantieri />;
      default:
        return <ResponsabileWorkHours />;
    }
  };

  return (
    <div className="admin-panel">
      {/* Header centrale simile alla dashboard admin */}
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <h2 style={{
          margin: '0 0 15px 0',
          fontSize: '2.2rem',
          color: '#e67e22',
          fontWeight: '700',
          textShadow: '0 2px 8px rgba(230, 126, 34, 0.2)'
        }}>
          Pannello Responsabile
        </h2>
        <p style={{
          margin: 0,
          color: '#6c757d',
          fontSize: '1.1rem',
          fontWeight: '500'
        }}>
          Gestisci le attività del tuo team
        </p>
      </div>

      {/* Tab navigation - stesso stile dell'admin */}
      <div className="admin-tabs">
        <button 
          className={`tab-button ${activeTab === 'hours' ? 'active' : ''}`}
          onClick={() => setActiveTab('hours')}
          style={{
            '--primary': '#e67e22'
          }}
        >
          📊 Gestione Ore
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'timekeeping' ? 'active' : ''}`}
          onClick={() => setActiveTab('timekeeping')}
          style={{
            '--primary': '#e67e22'
          }}
        >
          ⏰ Timbrature
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
          style={{
            '--primary': '#e67e22'
          }}
        >
          📝 Richieste
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'cantieri' ? 'active' : ''}`}
          onClick={() => setActiveTab('cantieri')}
          style={{
            '--primary': '#e67e22'
          }}
        >
          🏗️ I Miei Cantieri
        </button>
      </div>

      {/* Contenuto delle tab */}
      <div style={{ marginTop: '20px' }}>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ResponsabileDashboard;